import { Menu, Wifi, WifiOff, RefreshCw, LifeBuoy } from 'lucide-react';
import ChipUsuario from './ChipUsuario';
import BuscadorGlobal from './BuscadorGlobal';
import CentroNotificaciones from './CentroNotificaciones';

// Encabezado: nombre del sistema a la izquierda (alineado con la barra
// lateral), la búsqueda global al centro —disponible desde CUALQUIER
// módulo, que es lo que la hace útil— y a la derecha el estado de conexión
// + la campana de avisos y el chip de usuario con su rol siempre visible.
//
// La campana va AQUI y no en un módulo: un aviso que hay que ir a buscar
// no avisa. El stock bajo de un producto se enteraba quien pasara por la
// pantalla de Alertas, que en un almacén ocupado es nadie.
export default function Encabezado({ titulo, onMenu, usuario, online, enCola, onIr, onReportar }) {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-20 h-14 flex items-center gap-3 px-4">
      <button type="button" onClick={onMenu} aria-label="Abrir el menú de módulos"
              className="md:hidden text-gray-600 -ml-1 p-1 rounded
                         focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)]">
        <Menu className="h-6 w-6" aria-hidden="true" />
      </button>
      <span className="font-semibold text-gray-900 shrink-0 hidden sm:block md:w-52">TEGO Cloud</span>
      {onIr ? (
        <BuscadorGlobal onIr={onIr} />
      ) : (
        <div className="flex-1 text-center font-semibold text-gray-700 truncate">{titulo}</div>
      )}
      <div className="flex items-center gap-2 shrink-0">
        <Conexion online={online} enCola={enCola} onIr={onIr} />
        {/* PEDIR AYUDA A TI, junto a la campana (hallazgo del dueño, 26 sep
            2026): en pantalla ancha reemplaza al flotante, que tapaba la barra
            lateral. En el teléfono el label se esconde (queda el icono) porque
            ahí sigue el botón flotante; el `title` lo nombra al pasar el dedo. */}
        {onReportar && (
          <button
            type="button"
            onClick={onReportar}
            title="Pedir ayuda a TI"
            aria-label="Pedir ayuda a TI"
            className="inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 min-h-9 text-sm font-medium
                       text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)]"
          >
            <LifeBuoy className="h-5 w-5 shrink-0" aria-hidden="true" />
            <span className="hidden md:inline">Pedir ayuda a TI</span>
          </button>
        )}
        <CentroNotificaciones onIr={onIr} />
        {/* CUENTA C3: tocar el nombre abre «Mi cuenta» (módulo `mi-cuenta`,
            montado por el carril seguridad). */}
        <ChipUsuario nombre={usuario?.nombre} rol={usuario?.rol} tieneFoto={!!usuario?.tiene_foto} sello={usuario?.sello_foto || 0} onAbrir={onIr ? () => onIr('mi-cuenta') : undefined} />
      </div>
    </header>
  );
}

// EL CHIP DE CONEXIÓN · DIRECTRIZ-PWA F2 (DISENO-F2 §5). Antes se escondía
// en el teléfono (`hidden sm:`), que es justo donde se trabaja sin señal.
// Ahora se ve siempre que haya algo que decir: en teléfono, el icono y el
// número («3», con `aria-label` completo); desde `sm`, el texto. Pulsarlo
// abre «Pendientes de enviar». Con señal y nada pendiente, en teléfono no
// se pinta nada: ese espacio a 320 px es de la cabecera.
const CHIP = 'inline-flex items-center gap-1 min-h-9 px-1.5 rounded-lg text-xs font-semibold '
  + 'focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)]';

function Conexion({ online, enCola, onIr }) {
  const abrir = () => onIr?.('pendientes-de-enviar');
  const cuantos = enCola === 1 ? '1 pendiente de enviar' : `${enCola} pendientes de enviar`;
  if (!online) {
    return (
      <button type="button" onClick={abrir} title="Sin señal"
              aria-label={enCola > 0 ? `Sin señal: ${cuantos}` : 'Sin señal'}
              className={`${CHIP} text-red-600 hover:bg-red-50`}>
        <WifiOff className="h-4 w-4" aria-hidden="true" />
        {enCola > 0 && <span className="sm:hidden tabular-nums">{enCola}</span>}
        <span className="max-sm:hidden">{enCola > 0 ? cuantos : 'Sin señal'}</span>
      </button>
    );
  }
  if (enCola > 0) {
    return (
      <button type="button" onClick={abrir} title="Enviando lo pendiente"
              aria-label={`Enviando: ${cuantos}`}
              className={`${CHIP} text-[var(--color-marca)] hover:bg-[var(--color-marca-suave)]`}>
        <RefreshCw className="h-4 w-4" aria-hidden="true" />
        <span className="sm:hidden tabular-nums">{enCola}</span>
        <span className="max-sm:hidden">Enviando {enCola}</span>
      </button>
    );
  }
  return (
    <span title="En línea" className={`${CHIP} max-sm:hidden text-green-700`}>
      <Wifi className="h-4 w-4" aria-hidden="true" />En línea
    </span>
  );
}
